import { DeviceHardwareSummaryDto, DeviceHardwareClient } from '@/apiClients';

import authorizedClient from './authorizedClient';

export interface IDeviceHardwareSummaryDto {
  hardwareDevices: DeviceHardwareSummaryDto;
}

export default {
  namespaced: true,
  state: (): IDeviceHardwareSummaryDto =>
    ({
      hardwareDevices: {},
    }) as IDeviceHardwareSummaryDto,
  getters: {
    hardwareDevices: (state: IDeviceHardwareSummaryDto) => () => state.hardwareDevices,
  },
  mutations: {
    SET_HARDWARE_DEVICES(state: IDeviceHardwareSummaryDto, hardwareDevices: DeviceHardwareSummaryDto) {
      state.hardwareDevices = hardwareDevices;
    },
  },
  actions: {
    async getHardwareDevices({ commit }: { commit: any }, deviceId: string) {
      const deviceHardwareClient = await authorizedClient(DeviceHardwareClient);
      try {
        const hardwareDevices = await deviceHardwareClient.getHardwareDevices(
          deviceId,
          process.env.VUE_APP_TERMINAL_WEB_API_VERSION
        );
        if (hardwareDevices) {
          commit('SET_HARDWARE_DEVICES', hardwareDevices);
        }
      } catch (error) {
        throw error;
      }
    }
  }
};
